import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import log from 'lib/log'
import { loadGroup, loadAccessRequests } from 'actions/groups'
const component = universal(props => import('./GroupAccessRequestsPage.js'))

class AsyncGroupAccessRequestsPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    let {
      location: { type: place, payload: { group: groupId } },
      group: { value: { group, membership } = {} }
    } = getState()
    // make sure we have the group
    if (!group || group._id !== groupId) {
      try {
        group = await loadGroup({ _id: groupId })(dispatch, getState, opts)
      } catch (e) {
        log.error(e)
      }
    }

    // todo: only execute this if we are an admin of the group

    // and the pending access requests
    try {
      let result = await loadAccessRequests({ group: groupId })(
        dispatch,
        getState,
        opts
      )
    } catch (e) {
      log.error(e)
    }
  }
}

export default new AsyncGroupAccessRequestsPage()
